import React, { useEffect } from "react";
import TrainingCoursesHero from "../components/trainingCourse/TrainingCoursesHero";
 
import Navbar from "../components/homepage/Navbar";
import TrainingMap from "../components/trainingCourse/TrainingMap";
import { Header, Footer } from "../shared";

const TrainingCourses = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <TrainingCoursesHero />
      <TrainingMap />
      <Footer />
    </div>
  );
};

export default TrainingCourses;
